import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { getFieldsList } from "../../lib/api";
import { IField } from "../../types/api";
import { Table } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { alertActions } from "../../features/alert/alertSlice";
import { store } from "../..";
import { globalActions, selectFields } from "../../features/global/globalSlice";

export const loader = async () => {
    const fields = store.getState().global.fields;

    const fieldPromise = fields.length
        ? Promise.resolve()
        : store.dispatch(globalActions.getFields());

    await Promise.all([fieldPromise]);

    return null;
};

const FieldsIndex = (): React.JSX.Element | undefined => {
    const loadedFields = useAppSelector(selectFields);
    const [fields, setFields] = useState<IField[]>(loadedFields);
    const location = useLocation();

    useEffect(() => {
        setFields(loadedFields);
    }, [loadedFields, setFields]);

    const isOnFieldListPage = /fields\/?$/.test(location.pathname);

    return isOnFieldListPage ? (
        <div className="fieldListContent" data-testid="fieldListContent">
            <h2>Field List</h2>
            <Link
                to={`/tournament-management/fields/add`}
                className="btn btn-primary createButton"
            >
                Add New Field
            </Link>
            <Table striped borderless>
                <thead>
                    <tr>
                        <th>Field Name</th>
                        <th># Fields</th>
                        <th>Active</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {fields.map(f => (
                        <tr key={f.id}>
                            <td>{f.name}</td>
                            <td>{f.diamonds && f.diamonds.length}</td>
                            <td>{f.active ? "Active" : "Inactive"}</td>
                            <td>
                                <Link to={`edit/${f.id}`}>edit</Link>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    ) : (
        <Outlet context={[fields, setFields]} />
    );
};

export default FieldsIndex;
